import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  Checkbox,
} from "@material-ui/core";
import {
  useNotify,
  useRefresh,
  useListContext,
  useDataProvider,
} from "react-admin";
import { API } from "aws-amplify";
import Header from "../utils/auth/getHeader";

export const AssignTag = ({ open, handleClose }) => {
  const [selectedTags, setSelectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const { selectedIds, onUnselectItems } = useListContext();

  // Clear selectedTags when the dialog is opened
  useEffect(() => {
    if (open) {
      setSelectedTags([]);
    }
  }, [open]);

  useEffect(() => {
    setLoading(true);
    dataProvider
      .getList("tag", {
        pagination: { page: 1, perPage: 100 },
        sort: { field: "resource_name" },
        filter: {},
      })
      .then(({ data }) => {
        setTags(data);
      })
      .catch((error) => {
        notify("Error loading tags: " + error.message, { type: "warning" });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dataProvider, notify]);

  // Pre-select the user's existing tags when the modal opens
  useEffect(() => {
    if (open && selectedIds && selectedIds.length === 1) {
      // Fetch the selected user's profile (sk: 'profile') for tags
      setLoading(true);
      const userId = selectedIds[0].split('+')[0] + '+profile';
      dataProvider
        .getOne("user", { id: userId })
        .then(({ data }) => {
          console.log('AssignTag: fetched user profile:', data);
          console.log('AssignTag: user.tags:', data.tags);
          setSelectedTags(Array.isArray(data.tags) ? data.tags : []);
        })
        .catch((err) => {
          console.log('AssignTag: error fetching user:', err);
          setSelectedTags([]);
        })
        .finally(() => setLoading(false));
    } else if (open) {
      setSelectedTags([]);
    }
  }, [open, selectedIds, dataProvider]);

  const handleAssign = async () => {
    const isMultiple = selectedIds && selectedIds.length > 1;
    try {
      const header = await Header.getHeader();
      // Send an array of tag IDs
      await API.post("secure-api", "api/admin/tagassign", {
        headers: {
          ...header,
          "Access-Control-Allow-Headers": "*",
          "Access-Control-Allow-Origin": "*",
        },
        body: {
          user_ids: selectedIds,
          resource_ids: selectedTags, // Now an array
          multiple: isMultiple // true if more than one user selected, false if only one
        },
      });
      notify("Users updated successfully", { type: "info" });
      onUnselectItems();
      refresh();
      handleClose(); // close dialog on success
    } catch (error) {
      notify("Error: Users not updated", { type: "warning" });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Assign Tag</DialogTitle>
      <DialogContent>
        {loading ? (
          <p>Loading tags...</p>
        ) : (
          <FormControl fullWidth>
            <InputLabel id="tag-select-label">Tags</InputLabel>
            <Select
              labelId="tag-select-label"
              id="tag-select"
              multiple
              value={
                // Always use the tag.id (with suffix) for value
                tags.filter(tag => selectedTags.some(sel => String(sel).split('+')[0] === String(tag.id).split('+')[0])).map(tag => tag.id)
              }
              onChange={(e) => {
                // e.target.value is an array of tag ids (with suffix)
                setSelectedTags(e.target.value);
              }}
              renderValue={(selected) =>
                tags
                  .filter((tag) => selected.includes(tag.id))
                  .map((t) => t.resource_name)
                  .join(", ")
              }
            >
              {tags.map((tagItem) => (
                <MenuItem key={tagItem.id} value={tagItem.id}>
                  <Checkbox checked={selectedTags.some(sel => String(sel).split('+')[0] === String(tagItem.id).split('+')[0])} />
                  <ListItemText primary={tagItem.resource_name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleAssign} color="primary" disabled={loading}>
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};
